export { TestingPlaceholder } from './testing-placeholder';
export { FinishTestButton } from './finish-test-button';
export { TestingAnswers } from './testing-answers';
export { TestingNavigation } from './testing-navigation';
export { TestingQuestion } from './testing-question';
export { ButtonStartSubjectTest } from './button-start-subject-test';
